import Status from "@/enum/Status";
import { IBranch } from "@/services/api/models";

const MONTHS = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
];

export const buildReportTypes = () => [
    { label: 'Vigencia Cesión AON Desde', value: '1' },
    { label: 'Vigencia Cesión AON Hasta', value: '2' },
    { label: 'Fecha de Registro de la Solicitud', value: '3' },
];

export const buildYearOptions = () => {
    const years: number[] = [];
    for (let i = new Date().getFullYear(); i >= 2000; i--) {
        years.push(i);
    }
    return years.map((year) => ({ label: String(year), value: year }));
};

export const buildMonthOptions = () =>
    MONTHS.map((month, index) => ({ label: month, value: index + 1 }));

export const buildStatusOptions = (statuses: Record<Status, string>) =>
    Object.entries(statuses).map(([key, value]) => ({ label: value, value: key }));

export const buildBranchOptions = (branches: IBranch[]) =>
    branches.map((branch) => ({ label: branch.title, value: branch.id }));

export const buildTrimesterOptions = (trimesters: string[]) =>
    trimesters.map((trimester) => ({ label: trimester, value: trimester }));